module.exports = __webpack_public_path__ + "static/media/institution.31e87bed.svg";